export default "__VITE_ASSET__D62UdU70__"